"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { BLOG_CITIES } from "~/lib/blog/cities";
import type { TagInfo } from "~/lib/blog/posts";
import { cn } from "~/lib/utils";
type Item = {
  name: string;
  href: string;
};
const LINK_BASE = "flex h-11 items-center border-b-2 border-transparent px-4 text-[13px] font-semibold whitespace-nowrap text-muted transition-colors";
export function BlogSubNav(t0) {
  const $ = _c(47);
  const {
    categories
  } = t0;
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== pathname) {
    t2 = [pathname];
    $[1] = pathname;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== open) {
    t3 = () => {
      if (!open) {
        return;
      }
      const onKey = e => {
        if (e.key === "Escape") {
          setOpen(false);
        }
      };
      const onPointer = e_0 => {
        if (!wrapRef.current?.contains(e_0.target as Node)) {
          setOpen(false);
        }
      };
      document.addEventListener("keydown", onKey);
      document.addEventListener("pointerdown", onPointer);
      return () => {
        document.removeEventListener("keydown", onKey);
        document.removeEventListener("pointerdown", onPointer);
      };
    };
    t4 = [open];
    $[3] = open;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== categories) {
    t5 = categories.map(_temp);
    $[6] = categories;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const categoryItems = t5;
  let t6;
  if ($[8] !== categories) {
    t6 = new Set(categories.map(_temp2));
    $[8] = categories;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const taggedSlugs = t6;
  let t7;
  if ($[10] !== taggedSlugs) {
    t7 = BLOG_CITIES.filter(c_1 => taggedSlugs.has(c_1.slug)).map(_temp3);
    $[10] = taggedSlugs;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const cityItems = t7;
  let t8;
  if ($[12] !== pathname) {
    t8 = pathname.split("/");
    $[12] = pathname;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const segments = t8;
  const currentSlug = segments[2] === "category" ? segments[3] : undefined;
  let t9;
  if ($[14] !== categories || $[15] !== currentSlug) {
    t9 = currentSlug && categories.find(c_3 => c_3.slug === currentSlug)?.name || "Blog";
    $[14] = categories;
    $[15] = currentSlug;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const currentLabel = t9;
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setOpen(_temp4);
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = open && "rotate-180";
  let t12;
  if ($[18] !== t11) {
    t12 = cn("h-4 w-4 transition-transform", t11);
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12) {
    t13 = <ChevronDown className={t12} aria-hidden={true} />;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== currentLabel || $[23] !== open || $[24] !== t13) {
    t14 = <button type="button" aria-expanded={open} aria-controls="blog-mobile-menu" onClick={t10} className="mr-auto flex h-11 items-center gap-1.5 text-[15px] font-bold text-body md:hidden">{currentLabel}{t13}</button>;
    $[22] = currentLabel;
    $[23] = open;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = pathname === "/blog" && "border-(--blue) text-accent";
  let t16;
  if ($[26] !== t15) {
    t16 = cn(LINK_BASE, "hover:text-body", t15);
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16) {
    t17 = <Link href="/blog" className={t16}>Home</Link>;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== categoryItems) {
    t18 = <Dropdown label="Categories" items={categoryItems} />;
    $[30] = categoryItems;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== cityItems) {
    t19 = <Dropdown label="Cities" items={cityItems} />;
    $[32] = cityItems;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Link href="/parking" className={cn(LINK_BASE, "hover:text-body")}>Get the App</Link>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t17 || $[36] !== t18 || $[37] !== t19) {
    t21 = <div className="hidden items-center md:flex">{t17}{t18}{t19}{t20}</div>;
    $[35] = t17;
    $[36] = t18;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== categoryItems || $[40] !== cityItems || $[41] !== open) {
    t22 = open ? <div id="blog-mobile-menu" className="absolute inset-x-0 top-full z-50 border-b border-border bg-surface shadow-card md:hidden"><div className="mx-auto flex max-w-[1200px] flex-col px-lg py-3"><MobileLink href="/blog">Home</MobileLink><MobileSection label="Categories" items={categoryItems} /><MobileSection label="Cities" items={cityItems} /><MobileLink href="/parking">Get the App</MobileLink></div></div> : null;
    $[39] = categoryItems;
    $[40] = cityItems;
    $[41] = open;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t14 || $[44] !== t21 || $[45] !== t22) {
    t23 = <nav className="sticky top-(--nav-h) z-40 border-b border-border bg-surface px-lg"><div ref={wrapRef} className="relative mx-auto flex items-center justify-end">{t14}{t21}{t22}</div></nav>;
    $[43] = t14;
    $[44] = t21;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  return t23;
}
function _temp4(o) {
  return !o;
}
function _temp3(c_2) {
  return {
    name: c_2.name,
    href: `/blog/category/${c_2.slug}`
  };
}
function _temp2(c_0) {
  return c_0.slug;
}
function _temp(c) {
  return {
    name: c.name,
    href: `/blog/category/${c.slug}`
  };
}
function MobileLink(t0) {
  const $ = _c(6);
  const {
    href,
    children,
    indent
  } = t0;
  const t1 = indent && "py-2 pl-3 text-[13px] font-medium text-muted";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("block py-2.5 text-[14px] font-semibold text-secondary transition-colors hover:text-accent", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== href || $[4] !== t2) {
    t3 = <Link href={href} className={t2}>{children}</Link>;
    $[2] = children;
    $[3] = href;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function MobileSection(t0) {
  const $ = _c(7);
  const {
    label,
    items
  } = t0;
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== label) {
    t1 = <p className="pt-1 pb-0.5 text-[11px] font-bold uppercase tracking-[0.08em] text-muted">{label}</p>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== items) {
    t2 = items.map(_temp5);
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="border-t border-(--color-divider) pt-2">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp5(it) {
  return <MobileLink key={it.href} href={it.href} indent={true}>{it.name}</MobileLink>;
}
function Dropdown(t0) {
  const $ = _c(24);
  const {
    label,
    items
  } = t0;
  const [open, setOpen] = useState(false);
  const triggerRef = useRef(null);
  if (items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== label) {
    t1 = label.toLowerCase();
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const panelId = `blog-dd-${t1}`;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(true);
    t3 = () => setOpen(false);
    t4 = e => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setOpen(false);
      }
    };
    t5 = e_0 => {
      if (e_0.key === "Escape") {
        setOpen(false);
        triggerRef.current?.focus();
      }
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpen(_temp6);
    t7 = cn(LINK_BASE, "gap-1.5 group-hover:text-body");
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ChevronDown className="h-3 w-3 opacity-50" aria-hidden={true} />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== label || $[10] !== open || $[11] !== panelId) {
    t9 = <button ref={triggerRef} type="button" aria-haspopup="menu" aria-expanded={open} aria-controls={panelId} onClick={t6} className={t7}>{label}{t8}</button>;
    $[9] = label;
    $[10] = open;
    $[11] = panelId;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = open && "visible translate-y-0 opacity-100";
  let t11;
  if ($[13] !== t10) {
    t11 = cn("invisible absolute top-full right-0 z-50 min-w-[200px] -translate-y-1.5 rounded-(--r-lg) border border-border bg-surface py-2 opacity-0 shadow-card transition-[opacity,transform] duration-(--dur-fast) group-hover:visible group-hover:translate-y-0 group-hover:opacity-100", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== items) {
    t12 = items.map(_temp7);
    $[15] = items;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== panelId || $[18] !== t11 || $[19] !== t12) {
    t13 = <div id={panelId} role="menu" className={t11}>{t12}</div>;
    $[17] = panelId;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t9) {
    t14 = <div className="group relative flex items-center" onMouseEnter={t2} onMouseLeave={t3} onBlur={t4} onKeyDown={t5}>{t9}{t13}</div>;
    $[21] = t13;
    $[22] = t9;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}
function _temp7(it) {
  return <Link key={it.href} href={it.href} role="menuitem" className="block px-4 py-2 text-[13px] font-medium text-secondary transition-colors hover:bg-(--color-divider) hover:text-body">{it.name}</Link>;
}
function _temp6(o) {
  return !o;
}